import React from 'react';
import {
    Modal,
    Text,
} from './SessionExpiredDialog.style';
import { useSelector } from 'react-redux';
import { Status, } from '@api';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const SessionExpiredDialog = ({
    handleClick,
}) => {
    const sessionStatus = useSelector(state => state.auth.sessionStatus);

    const {t} = useTranslation();

    return (
        <Modal
            title={t('session_exp')}
            open={sessionStatus === Status.ERROR}
            closable={false}
            footer={false}
            width={400}
            centered
        >
            <Text>
                {t('session_exp_text')}
            </Text>
            <Button
                type='primary'
                onClick={handleClick}
            >
                {t('ok')}
            </Button>
        </Modal>
    );
}

export default SessionExpiredDialog;